import { render } from "./VitalsPage.vue?vue&type=template&id=5f0159f5&scoped=true"
import script from "./VitalsPage.vue?vue&type=script&lang=js"
export * from "./VitalsPage.vue?vue&type=script&lang=js"

import "./VitalsPage.vue?vue&type=style&index=0&id=5f0159f5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0159f5"]])

export default __exports__